import { StatusBadge } from '@/components/status-badge';
import { cpuStatus } from '@/lib/status';
import { formatPercent } from '@/lib/format';

export function CpuCell({ cpu }: { cpu: number | null }) {
  if (cpu === null) {
    return <span className="text-muted-foreground text-sm">N/A</span>;
  }

  const status = cpuStatus(cpu);

  if (status === 'healthy') {
    return <span className="text-muted-foreground text-sm">{formatPercent(cpu)}</span>;
  }

  return <StatusBadge status={status} label={formatPercent(cpu)} />;
}
